/* TOLUN: mağaza genelinde gerçek Shopify sepeti, tek saat = tek sayaç birimi */
(() => {
  'use strict';
  if (window.TolunCartDrawer) return;
  const root=window.Shopify?.routes?.root || '/';
  const prefix=root.endsWith('/')?root:root+'/';
  const drawer=document.getElementById('tolunCartDrawer');
  const shade=document.getElementById('tolunCartShade');
  if(!drawer||!shade)return;
  const body=drawer.querySelector('[data-tolun-drawer-body]');
  const foot=drawer.querySelector('[data-tolun-drawer-foot]');
  const error=drawer.querySelector('[data-tolun-drawer-error]');
  const badges=[...document.querySelectorAll('[data-tolun-cart-count]')];
  const money=cents=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format((Number(cents)||0)/100);
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let busy=false,opened=false,seq=0,previousFocus=null,latestCart=null;
  const displayPartName=value=>String(value??'').replace(/İbre/g,'Kol').replace(/ibre/g,'kol');
  async function fetchCart(){
    const r=await fetch(prefix+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!r.ok)throw new Error('Sepet okunamadı. İnternet bağlantınızı kontrol edin.');
    return r.json();
  }
  function groups(cart){
    const map=new Map();
    (cart.items||[]).forEach(item=>{
      const id=item.properties?._TolunGrup;
      const key=id?'tolun:'+id:'single:'+item.key;
      if(!map.has(key))map.set(key,{id:id||null,items:[]});
      map.get(key).items.push(item);
    });
    return [...map.values()];
  }
  function quantity(cart){
    return groups(cart).reduce((sum,g)=>{
      if(!g.id)return sum+(g.items[0]?.quantity||0);
      const parent=g.items.find(i=>i.properties?.['Parça']==='Ana saat');
      return sum+(parent?.quantity||g.items[0]?.quantity||0);
    },0);
  }
  function setBadge(cart){
    const n=quantity(cart);
    badges.forEach(b=>{b.textContent=n>99?'99+':String(n);b.hidden=n<1;});
    document.querySelectorAll('[data-tolun-cart-trigger]').forEach(el=>el.setAttribute('aria-label',`Sepet, ${n} ürün`));
  }
  function showError(msg){error.textContent=msg||'';error.hidden=!msg;}
  // Yalnızca kaldırma isteği sürerken ödeme bağlantısını devre dışı bırak.
  const checkout=foot.querySelector('.tolun-drawer__checkout');
  const status=document.createElement('p');
  status.className='tolun-drawer__status';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  status.hidden=true;
  foot.insertBefore(status,foot.firstChild);
  function pending(message){
    status.textContent=message||'';
    status.hidden=!message;
    if(checkout){
      checkout.setAttribute('aria-disabled',message?'true':'false');
      checkout.tabIndex=message?-1:0;
      checkout.classList.toggle('is-pending',!!message);
    }
  }
  checkout?.addEventListener('click',event=>{
    if(busy){event.preventDefault();showError('Sepet güncelleniyor, lütfen kısa bir süre bekleyin.');}
  });
  function render(cart){
    latestCart=cart;
    setBadge(cart);
    const list=groups(cart);
    if(!list.length){body.innerHTML='<div class="tolun-drawer__empty">Sepetiniz henüz boş.<br>Size özel saatinizi tasarlayabilirsiniz.</div>';foot.hidden=true;return;}
    foot.hidden=false;
    body.innerHTML=list.map((g,index)=>{
      const parent=g.items.find(i=>i.properties?.['Parça']==='Ana saat');
      const count=parent?.quantity||g.items[0]?.quantity||1;
      const title=g.id?'TOLUN Kişiselleştirilmiş Saat':displayPartName(g.items[0].product_title);
      const price=g.items.reduce((sum,i)=>sum+i.final_line_price,0);
      const rows=g.items.filter(i=>i.properties?.['Parça']!=='Ana saat'||!g.id).map(i=>{
        const label=i.properties?.['Parça']||i.product_title;
        const choice=i.properties?.['Seçim']||i.variant_title||'';
        const img=i.image?`<img src="${esc(i.image)}" alt="" loading="lazy">`:'<div class="tolun-drawer__placeholder"></div>';
        return `<div class="tolun-drawer__row">${img}<div class="tolun-drawer__rowdesc">${esc(displayPartName(label))}${choice&&choice!=='Default Title'?`<span>${esc(displayPartName(choice))}</span>`:''}</div> ${i.final_line_price > 0
  ? `<div class="tolun-drawer__rowprice">${money(i.final_line_price)}</div>`
  : ''}</div>`;
      }).join('');
      return `<section class="tolun-drawer__group"><div class="tolun-drawer__grouphead"><div><strong>${esc(title)}</strong><small>${count} adet${g.id?' · 4 özel parça':''}</small></div><button type="button" class="tolun-drawer__remove" data-tolun-remove="${index}">Kaldır</button></div>${rows}<div class="tolun-drawer__groupprice">${money(price)}</div></section>`;
    }).join('');
    foot.querySelector('[data-tolun-drawer-total]').textContent=money(cart.total_price);
    body.querySelectorAll('[data-tolun-remove]').forEach(b=>b.addEventListener('click',()=>removeGroup(list[Number(b.dataset.tolunRemove)])));
  }
  async function refresh(){
    const token=++seq;
    const cart=await fetchCart();
    if(!busy && token===seq && opened)render(cart);else if(!busy && token===seq){latestCart=cart;setBadge(cart);}
    return cart;
  }
  function open(){
    previousFocus=document.activeElement;
    opened=true;drawer.hidden=false;shade.hidden=false;
    document.body.classList.add('tolun-drawer-open');
    drawer.setAttribute('aria-hidden','false');
    requestAnimationFrame(()=>{drawer.classList.add('is-open');shade.classList.add('is-open');drawer.querySelector('[data-tolun-drawer-close]')?.focus();});
    showError('');body.innerHTML='<p class="tolun-drawer__empty">Sepet yükleniyor…</p>';
    refresh().catch(e=>showError(e.message));
  }
  function close(){
    opened=false;drawer.classList.remove('is-open');shade.classList.remove('is-open');
    document.body.classList.remove('tolun-drawer-open');drawer.setAttribute('aria-hidden','true');
    const finish=()=>{if(opened)return;drawer.hidden=true;shade.hidden=true;previousFocus?.focus?.();};
    setTimeout(finish,310);
  }
  async function change(key){
    const r=await fetch(prefix+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:0})});
    if(!r.ok){const e=await r.json().catch(()=>({}));throw new Error(e.description||'Ürün sepetten kaldırılamadı.');}
  }
  // Tek API isteğiyle grubun bütün satırlarını kaldırmayı dener. Shopify
  // satır anahtarlarını değiştirirse doğrulama ve yedek yöntem devreye girer.
  async function bulkRemove(items){
    const updates=Object.fromEntries(items.map(item=>[item.key,0]));
    const r=await fetch(prefix+'cart/update.js',{
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({updates})
    });
    if(!r.ok){const data=await r.json().catch(()=>({}));throw new Error(data.description||'Sepet güncellenemedi.');}
    return r.json();
  }
  async function removeGroup(g){
    if(busy)return;
    busy=true;
    showError('');
    // Hemen ekrandan kaldır: arka planda Shopify isteği sürer.
    // Başarısız olursa sunucudaki gerçek sepet geri gösterilir.
    const snapshot=latestCart;
    const isTarget=item=>g.id?item.properties?._TolunGrup===g.id:item.key===g.items[0].key;
    const selected=(snapshot?.items||g.items).filter(isTarget);
    if(!selected.length){busy=false;refresh().catch(e=>showError(e.message));return;}
    const removedPrice=selected.reduce((sum,item)=>sum+(item.final_line_price||0),0);
    const optimistic={...snapshot,items:(snapshot?.items||[]).filter(item=>!isTarget(item)),
      total_price:Math.max(0,(snapshot?.total_price||0)-removedPrice)};
    // Sayaç hemen değişir; grup kısa ve yumuşak bir çıkışla kaldırılır.
    setBadge(optimistic);
    pending('Sepetiniz güncelleniyor…');
    body.querySelectorAll('button').forEach(b=>b.disabled=true);
    const targetIndex=groups(snapshot||{items:[]}).findIndex(group=>group.id===g.id &&
      (g.id || group.items[0]?.key===g.items[0]?.key));
    const target=opened && targetIndex>=0
      ? body.querySelectorAll('.tolun-drawer__group')[targetIndex] : null;
    const animateOut=()=>new Promise(resolve=>{
      if(!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        if(opened)render(optimistic);
        resolve();return;
      }
      const height=target.getBoundingClientRect().height;
      target.style.height=height+'px';
      target.style.overflow='hidden';
      target.style.boxSizing='border-box';
      target.offsetHeight;
      target.classList.add('is-removing');
      target.style.height='0px';
      window.setTimeout(()=>{
        if(opened)render(optimistic);
        resolve();
      },280);
    });
    try{
      // Shopify güncellenirken animasyon devam eder; ağ isteğini bekletmeyiz.
      const removal=bulkRemove(selected).then(data=>({ok:true,data}),error=>({ok:false,error}));
      await animateOut();
      const result=await removal;
      if(!result.ok)throw result.error;
      let updated=await fetchCart();
      // Çok istisnai olarak kalan satırlar olursa orijinal güvenli yöntem.
      for(let attempt=0;attempt<8 && updated.items.some(isTarget);attempt++){
        const item=updated.items.find(isTarget);
        await change(item.key);
        updated=await fetchCart();
      }
      if(updated.items.some(isTarget)){
        showError('Bazı parçalar kaldırılamadı. Lütfen sepetinizi kontrol edin.');
      }
      latestCart=updated;
      if(opened)render(updated);else setBadge(updated);
      window.dispatchEvent(new CustomEvent('tolun:cart-updated',{detail:{cart:updated}}));
    }catch(e){
      showError('Kaldırma işlemi tamamlanamadı: '+(e.message||'Lütfen tekrar deneyin.'));
      // Ağ hatasında durum belirsiz olabilir: yalnızca güncel sunucu verisini göster.
      try{const actual=await fetchCart();latestCart=actual;if(opened)render(actual);else setBadge(actual);
        window.dispatchEvent(new CustomEvent('tolun:cart-updated',{detail:{cart:actual}}));
      }catch(_){
        // Sunucuya ulaşamıyorsak yanlışlıkla ürün silinmiş gibi göstermeyelim.
        if(snapshot){latestCart=snapshot;if(opened)render(snapshot);else setBadge(snapshot);}
        showError('Bağlantı kurulamadı. Sepet durumunu doğrulamak için sayfayı yenileyin.');
      }
    }finally{
      busy=false;
      pending('');
      body.querySelectorAll('button').forEach(b=>b.disabled=false);
    }
  }
  document.querySelectorAll('[data-tolun-cart-trigger]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();open();}));
  drawer.querySelector('[data-tolun-drawer-close]').addEventListener('click',close);
  shade.addEventListener('click',close);
  drawer.querySelector('[data-tolun-drawer-continue]').addEventListener('click',close);
  document.addEventListener('keydown',e=>{
    if(!opened)return;
    if(e.key==='Escape')close();
    // Kullanıcı klavyeyle çalışırken odak yan sepet dışında kaymasın.
    if(e.key==='Tab'){
      const els=[...drawer.querySelectorAll('a,button,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
      if(!els.length)return;
      const first=els[0],last=els[els.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  window.addEventListener('tolun:cart-updated',e=>{if(busy)return;if(e.detail?.cart){if(opened)render(e.detail.cart);else{latestCart=e.detail.cart;setBadge(e.detail.cart);}}else refresh().catch(()=>{});});
  window.addEventListener('pageshow',()=>refresh().catch(()=>{}));
  // Dış kod, yeni saat eklenince sepet sayfasına gitmeden sepeti açabilir.
  window.TolunCartDrawer={open,close,refresh,groups,quantity};
  refresh().catch(()=>{});
})();
